import { SiteDTO } from '@luminovo/api-contracts';

export const formatSiteAddress = (site: SiteDTO): string => {
    const address = site.address;
    if (!address) {
        return '-';
    }

    const { streetAddress, postcode } = address;

    if (streetAddress && postcode) {
        return `${streetAddress}, ${postcode}`;
    } else if (streetAddress && !postcode) {
        return streetAddress;
    } else if (!streetAddress && postcode) {
        return postcode;
    } else {
        return '-';
    }
};
